import {
  Box,
  Grid,
  TextField,
  Typography,
  Card,
  CardContent,
} from '@mui/material';
import { FormularioComunidades } from 'interfaces/formularioComunidades.interface';

import { IComunidadesRuraisTradicionais } from 'stores/forms/comunidades_rurais_tradicionais';

interface ViewStep2Props {
  formData: IComunidadesRuraisTradicionais & FormularioComunidades;
}

export const ViewStep2: React.FC<ViewStep2Props> = ({
  formData,
}) => {
  const formatBooleanValue = (value: boolean | null) => {
    if (value === null || value === undefined) return '';
    return value ? 'Sim' : 'Não';
  };

  const escolas = formData.escolas;

  return (
    <Box sx={{ mt: 4 }}>
      <Typography
        variant='h5'
        gutterBottom
        sx={{ fontWeight: 'bold', mb: 4 }}
      >
        Infraestrutura
      </Typography>

      {/* Serviços Básicos */}
      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={6}>
          <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
            6 - Possui energia elétrica?
          </Typography>
          <TextField
            fullWidth
            value={formatBooleanValue(formData.possui_energia_eletrica)}
            InputProps={{
              readOnly: true,
              sx: { backgroundColor: '#f5f5f5' },
            }}
          />
        </Grid>

        <Grid item xs={6}>
          <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
            7 - Possui saneamento básico?
          </Typography>
          <TextField
            fullWidth
            value={formatBooleanValue(formData.possui_saneamento_basico)}
            InputProps={{
              readOnly: true,
              sx: { backgroundColor: '#f5f5f5' },
            }}
          />
        </Grid>
      </Grid>

      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={6}>
          <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
            8 - Coleta de lixo?
          </Typography>
          <TextField
            fullWidth
            value={formatBooleanValue(formData.coleta_de_lixo)}
            InputProps={{
              readOnly: true,
              sx: { backgroundColor: '#f5f5f5' },
            }}
          />
        </Grid>

        <Grid item xs={6}>
          <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
            9 - Recebeu manutenção das estradas no último ano?
          </Typography>
          <TextField
            fullWidth
            value={formatBooleanValue(formData.recebeu_manutencao_das_estradas_no_ultimo_ano)}
            InputProps={{
              readOnly: true,
              sx: { backgroundColor: '#f5f5f5' },
            }}
          />
        </Grid>
      </Grid>

      {/* Educação */}
      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={6}>
          <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
            10 - Possui escolas?
          </Typography>
          <TextField
            fullWidth
            value={formatBooleanValue(formData.possui_escolas)}
            InputProps={{
              readOnly: true,
              sx: { backgroundColor: '#f5f5f5' },
            }}
          />
        </Grid>

        <Grid item xs={6}>
          <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
            11 - Possui oferta de transporte escolar para os estudantes?
          </Typography>
          <TextField
            fullWidth
            value={formatBooleanValue(formData.possui_oferta_de_transporte_escolar_para_os_estudantes)}
            InputProps={{
              readOnly: true,
              sx: { backgroundColor: '#f5f5f5' },
            }}
          />
        </Grid>
      </Grid>

      {/* Detalhes das Escolas */}
      {formData.possui_escolas === true && escolas.length > 0 && (
        <Box sx={{ mb: 4 }}>
          <Typography variant='h6' gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
            Escolas Cadastradas ({escolas.length})
          </Typography>

          {escolas.map((escola, index) => (
            <Card key={index} sx={{
              mb: 2, backgroundColor: '#f9f9f9',
              border: '1px solid #e0e0e0',
              borderRadius: '8px',
              padding: '16px',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
              transition: 'transform 0.2s',
              '&:hover': {
                transform: 'translateY(-2px)',
              },
            }}>
              <CardContent>
                <Typography variant='subtitle1' gutterBottom sx={{ fontWeight: 'bold' }}>
                  Escola {index + 1}
                </Typography>

                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Typography variant='body2' sx={{ fontWeight: 'bold', mb: 1 }}>
                      Jurisdição:
                    </Typography>
                    <Typography variant='h6'>
                      {escola.jurisdicao || 'Não informado'}
                    </Typography>
                  </Grid>

                  <Grid item xs={6}>
                    <Typography variant='body2' sx={{ fontWeight: 'bold', mb: 1 }}>
                      Nome:
                    </Typography>
                    <Typography variant='h6'>
                      {escola.nome || 'Não informado'}
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          ))}
        </Box>
      )}

      {/* Saúde */}
      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={6}>
          <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
            12 - Possui unidade de saúde?
          </Typography>
          <TextField
            fullWidth
            value={formatBooleanValue(formData.possui_unidade_de_saude)}
            InputProps={{
              readOnly: true,
              sx: { backgroundColor: '#f5f5f5' },
            }}
          />
        </Grid>

        <Grid item xs={6}>
          <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
            13 - Recebe agentes de saúde do município?
          </Typography>
          <TextField
            fullWidth
            value={formatBooleanValue(formData.recebeu_agentes_de_saude_do_municipio)}
            InputProps={{
              readOnly: true,
              sx: { backgroundColor: '#f5f5f5' },
            }}
          />
        </Grid>
      </Grid>

      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={12}>
          <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
            14 - Tem acesso à internet?
          </Typography>
          <TextField
            fullWidth
            value={formatBooleanValue(formData.tem_acesso_internet)}
            InputProps={{
              readOnly: true,
              sx: { backgroundColor: '#f5f5f5' },
            }}
          />
        </Grid>
      </Grid>

    </Box>
  );
};
